import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/login';
import { AuthProvider, useAuth } from './context/AuthContext';
import Dashboard from './pages/dashboard';
import AdminPanel from './pages/admin-panel';
import Layout from './layout';
import AddUserPage from './pages/add-user-page'
import NaoAutorizadoPage from './pages/nao-autorizado';
import { PageAccessTracker } from './tracking/PageAccessTracker';
import "./App.css";

const AuthLoading = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
    Carregando...
  </div>
);

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isInitialized } = useAuth();
  if (!isInitialized) return <AuthLoading />;
  return user ? <>{children}</> : <Navigate to="/painel-central" replace />;
};

const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, isInitialized } = useAuth();
  if (!isInitialized) return <AuthLoading />;
  return user ? <Navigate to="/painel-central/dashboard" replace /> : <>{children}</>;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <PageAccessTracker />
        <Routes>

          {/* LOGIN */}
          <Route
            path="/painel-central"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />

          {/* DASHBOARD */}
          <Route
            path="/painel-central/dashboard"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* ADMIN PANEL */}
          <Route
            path="/painel-central/admin-panel"
            element={
              <PrivateRoute>
                <Layout routeBack="dashboard">
                  <AdminPanel />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route path="/nao-autorizado" element={<NaoAutorizadoPage />} />

          {/* ADD / EDIT USER */}
          <Route
            path="/painel-central/add-user"
            element={
              // <PrivateRoute>
              <Layout routeBack="admin-panel">
                <AddUserPage />
              </Layout>
              // </PrivateRoute>
            }
          />

          <Route
            path="/painel-central/add-user/:email"
            element={
              // <PrivateRoute>
              <Layout routeBack="admin-panel">
                <AddUserPage />
              </Layout>
              // </PrivateRoute>
            }
          />

          {/* FALLBACK */}
          <Route path="*" element={<Navigate to="/painel-central" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
